import { render, staticRenderFns } from "./UpdateAttendance.vue?vue&type=template&id=2c0822b0&scoped=true&"
import script from "./UpdateAttendance.vue?vue&type=script&lang=js&"
export * from "./UpdateAttendance.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./UpdateAttendance.vue?vue&type=style&index=1&id=2c0822b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0822b0",
  null
  
)

export default component.exports